export default __webpack_public_path__ + "static/media/enjoy-movie.66534711.png";